import React, { useRef } from "react";
import "./ImgContainer.css";
import { useScrollReveal } from "../../../custom-hooks/useScrollReveal";

export const ImgContainer = ({ img, containerStyle, imgStyles }: any) => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useScrollReveal(sectionRef, {
    selectorList: [".reveal-item"],
    maxBlur: 8,
    gapFactor: 2,
  });
  return (
    <div
      className={`imgcontainer-section-container`}
      style={containerStyle ? containerStyle : {}}
      ref={sectionRef}
    >
      <img
        src={img}
        alt="imgcontainer section"
        className="imgcontainer-section-image reveal-item test"
        style={imgStyles ? imgStyles : {}}
      />
    </div>
  );
};
